import { logging } from '@cornerstonejs/utils';
export const { getRootLogger, getLogger, cs3dLog, workerLog, coreLog, toolsLog, loaderLog, aiLog, examplesLog, dicomConsistencyLog, imageConsistencyLog, } = logging;
